import { useSyncExternalStore } from 'react';

import type { StatoTempoReale } from './tempoReale';

/**
 * Lo stato del collegamento a `qsocials-ws`, UNO per app: lo scrive il collegamento montato in
 * `AppShell`, lo legge chi deve decidere se ricontrollare da se' (la pagina Amici, R4).
 */
let stato: StatoTempoReale = 'spento';
const ascoltatori = new Set<() => void>();

export function impostaStatoTempoReale(nuovo: StatoTempoReale): void {
  if (nuovo === stato) return;
  stato = nuovo;
  ascoltatori.forEach((f) => f());
}

export function statoTempoReale(): StatoTempoReale {
  return stato;
}

function iscrivi(f: () => void): () => void {
  ascoltatori.add(f);
  return () => ascoltatori.delete(f);
}

export function useStatoTempoReale(): StatoTempoReale {
  return useSyncExternalStore(iscrivi, statoTempoReale, statoTempoReale);
}
